import React, { useEffect, useState, useMemo } from 'react';
import { Modal, ModalBody, ModalHeader, Button, ButtonToolbar, Row, Col, Input, FormGroup, Label, ModalFooter } from 'reactstrap';
import { connect } from 'react-redux';
import { ThemeProps, RTLProps } from '@/shared/prop-types/ReducerProps';
import { Form, Field, useForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { FieldArray } from 'react-final-form-arrays';
import axios from 'axios';
import {flashDispatch, flashMessage, amountToUsFormat, formatFloatValue, formatApiErrors}  from "@/shared/helpers";
import renderSelectField from '@/shared/components/form/Select';
import RadioButtonField from '@/shared/components/form/RadioButton';
import getStatesByCountry from '@/services/getStatesByCountry';
import { labelizeNamedData } from '@/shared/helpers';
import SelectProgram from '@/containers/Manager/components/SelectProgram';
import { getProgram } from "@/services/program/getProgram";
import BankIcon from 'mdi-react/BankIcon';
import CreditCardIcon from 'mdi-react/CreditCardIcon';
import PropTypes from 'prop-types';
import { useAcceptBluePayment } from '@/containers/Manager/ManageAccount/hooks/useAcceptBluePayment';
import { assert3DS } from '@/services/program/assert3DS';
import { depositByAcceptBlue } from '@/services/program/transferMonies';
import { resolveDepositHoldId, checkoutStatusMessage } from '@/utils/depositHoldCheckout';

const COUNTRY_ID = 223; // USA
const PhysicalCardModal = ({ isOpen, toggle, program, organization, theme, rtl, auth, setRefreshUsers,balance }) => {
const [states, setStates] = useState([]);
const [loading, setLoading] = useState(false);
const [merchants, setMerchants] = useState([]);
const loggedInUserName = auth ? `${auth?.first_name} ${auth?.last_name}` : '';
const [denominations, setDenominations] = useState([]);
const [denominationOptions, setDenominationOptions] = useState([]);
const [merchantOptions, setMerchantOptions] = React.useState([]);
const [selectedProgram, setSelectedProgram] = useState(program);
const [merchantID, setMerchantID] = useState(null);
const [showTnC, setShowTnC] = useState(false);
const formRef = React.useRef(null);
const dispatch = flashDispatch();
const availableBalance = balance != null ? amountToUsFormat(balance, true, "$") : '0.00';
const ab = useAcceptBluePayment();
const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('balance');
const [cardBilling, setCardBilling] = useState({ first_name: '', last_name: '', name_on_card: '' });

const initialValues = useMemo(() => ({
    program_id: program.id, 
    contactName: loggedInUserName, 
    name: program.name,
    address: program?.address?.address || '',
    address2: program?.address?.address_ext || '',
    city: program?.address?.city || '',
    zip: program?.address?.zip || '',
    state_id: program?.address?.state ? { value: program.address.state.id, label: program.address.state.name } : null,
    recipients: Array(5).fill({ firstName: '', lastName: '', address: '', amount: '' }),
    payment_method: 'balance',
    denomination_rows: [{ denomination: null, qty: 1 }],
}), [program, loggedInUserName]);

  useEffect( () => {
    if( organization?.id )
    {
        getStatesByCountry(223)
        .then( result => {
            setStates(labelizeNamedData(result))
        })
        .catch(err => console.error("Error fetching states", err));
    }
    // alert(COUNTRY_ID);
  }, [organization])

  useEffect(() => {
    if (organization?.id && program?.id) {
        // Fetch Merchants
        axios.get(`organization/${organization.id}/program/${program.id}/visa-card-merchant`)
            .then(res => {
                // Assuming the API returns an array of merchant objects
                setMerchants(res?.data?.merchants);
                const merchantList = res?.data?.merchants || [];
                // Format for the select dropdown
                const formattedMerchants = merchantList.map(m => ({
                    value: String(m.id),
                    label: m.name
                }));
                setMerchantOptions(formattedMerchants);
            })
            .catch(err => console.error("Error fetching merchants", err));
    }
  }, [organization, program]);

 useEffect(() => {
    if ((merchants && merchants?.length > 0) && (merchantOptions && merchantOptions?.length > 0)) {
        // If the form doesn't have a value yet, or it's a raw primitive, set the proper object
        if (formRef.current) {
            const currentFormVal = formRef.current.getState().values.merchant_id;
            // If nothing is selected yet, select the first option object
            if (!currentFormVal) {
                const firstOption = merchantOptions[0];
                formRef.current.change('merchant_id', firstOption);
                setMerchantID(firstOption.value);
            }
        }
    }
}, [merchants, merchantOptions]);

useEffect(() => {
    if (merchantID && organization?.id && program?.id) {
        handleMerchantChange(merchantID, organization.id, program.id);
    }
}, [merchantID, organization?.id, program?.id]);

useEffect(() => {
    if (isOpen && selectedPaymentMethod === 'credit_card') {
        ab.mountContainer('#accept-blue-container-physical');
    } else {
        ab.destroy();
    }
    return () => ab.destroy();
}, [selectedPaymentMethod, isOpen]);

useEffect(() => {
    if (!isOpen) {
        setSelectedPaymentMethod('balance');
        setCardBilling({ first_name: '', last_name: '', name_on_card: '' });
    }
}, [isOpen]);

  const handleMerchantChange = async (merchantId, orgId, progId) => {
    if (!merchantId) return;
    if (formRef.current) {
        formRef.current.change('denomination_rows', [{ denomination: null, qty: 1 }]);
    }
    try {
        const res = await axios.get(`organization/${orgId}/program/${progId}/merchant/${merchantId}/redeemable`);
        
        // Ensure we handle different API response structures
        const rawData = res.data?.results || res.data || [];
        
        // Format for your renderSelectField (labelizeNamedData or manual map)
        const formatted = rawData.map(val => {
            return {
                value: val.medium_info_id,
                label: `$${formatFloatValue(val.redemption_value)}`
            };
        });
        
        setDenominations(rawData);
        setDenominationOptions(formatted);

        if (formRef.current) {
            formRef.current.change('denomination_rows', [{ denomination: formatted[0] || null, qty: 1 }]);
        }
    } catch (err) {
        console.error("Error fetching denominations", err);
        setDenominations([]);
        setDenominationOptions([]);
    }
};

    // Helper function to check if string contains only letters and spaces
    const isValidName = (value) => {
        // Allow letters, spaces, hyphens, and apostrophes but no numbers
        return /^[a-zA-Z\s'-]*$/.test(value);
    };

    const onBillingChange = (field) => (e) => {
        const value = e.target.value;

        // Validate first_name and last_name to reject numeric values
        if (field === 'first_name' || field === 'last_name' || field === 'name_on_card') {
            if (!isValidName(value)) {
                // Don't update the field if it contains invalid characters
                return;
            }
        }

        setCardBilling((prev) => ({ ...prev, [field]: value }));
    };

  const onSubmitForm = async (values) => {
        setLoading(true);
        try {
            const selectedMerchantId = values.merchant_id?.value || values.merchant_id;
            const rows = values.denomination_rows || [];
            const quantity = rows.reduce((sum, row) => sum + (parseInt(row.qty, 10) || 0), 0) || 1;
            const currentMerchant = merchants.find(
                (m) => String(m.id) === (values.merchant_id?.value || values.merchant_id)
            );
            const perCardFulfillmentFee = currentMerchant?.fulfillment_fee_per_card || 0.50;
            const visaPremiumFee = parseFloat(currentMerchant?.visa_premium_fee) || 0;
            const cardsSubtotal = rows.reduce((sum, row) => {
                const d = denominations.find(dm => dm.medium_info_id === (row.denomination?.value || row.denomination));
                const price = d?.redemption_value ? parseFloat(d.redemption_value) : 0;
                const qty = parseInt(row.qty, 10) || 0;
                return sum + (price * qty);
            }, 0);
            const premiumFeeTotal = (cardsSubtotal * visaPremiumFee) / 100;
            const totalFulfillmentFee = parseFloat(perCardFulfillmentFee) * quantity;
            const shipping = getShippingCost(quantity, selectedMerchantId);
            const convenienceFeeRate = parseFloat(selectedProgram?.convenience_fee) || 0;
            const convenienceBase = cardsSubtotal + premiumFeeTotal + totalFulfillmentFee + shipping;
            const calculatedConvenienceFee = values?.payment_method === 'credit_card' ? (convenienceBase * convenienceFeeRate) / 100 : 0;
            const items = rows.map(row => {
                const d = denominations.find(dm => dm.medium_info_id === (row.denomination?.value || row.denomination));
                return {
                    merchant_id: values.merchant_id?.value || '',
                    merchant_account_holder_id: currentMerchant?.account_holder_id || '',
                    merchant_name: currentMerchant?.name || '',
                    merchant_icon: currentMerchant?.icon || '',
                    medium_info_id: row.denomination?.value,
                    redemption_value: d?.redemption_value ? parseFloat(d.redemption_value).toFixed(4) : '0.0000',
                    redemption_fee: d?.redemption_fee ? parseFloat(d.redemption_fee).toFixed(4) : '0.0000',
                    sku_value: d?.sku_value ? parseFloat(d.sku_value).toFixed(4) : '0.0000',
                    virtual_inventory: d?.virtual_inventory || 0,
                    virtual_redemption_value: d?.virtual_redemption_value ? parseFloat(d.virtual_redemption_value).toFixed(4) : '0.0000',
                    //qty: parseInt(row.qty, 10) || 1,
                    qty: 1,
                    count: d?.count || 0,
                };
            });

            let depositHoldId = null;
            if (values.payment_method === 'credit_card') {
                if (!cardBilling.first_name.trim() || !cardBilling.last_name.trim()) {
                    dispatch(flashMessage('Please enter the cardholder first and last name.', 'alert-danger', 'top'));
                    return;
                }
                const { nonce, expiryMonth, expiryYear } = await ab.getNonceToken();
                const orderTotal = cardsSubtotal + premiumFeeTotal + totalFulfillmentFee + shipping + calculatedConvenienceFee;
                const paayBilling = {
                    line1: values.address || '',
                    city: values.city || '',
                    state: values.state_id?.label || '',
                    postCode: values.zip || '',
                    country: '840',
                };
                const tds = await ab.verify3DS({
                    amount:  formatFloatValue(orderTotal),
                    billing: paayBilling
                });
                if (!assert3DS(tds)) {
                    dispatch(flashMessage('3-D Secure authentication failed. Please try another card.', 'alert-danger', 'top'));
                    return;
                }
                const amountTotal = cardsSubtotal + premiumFeeTotal + totalFulfillmentFee + shipping;

                const depositResp = await depositByAcceptBlue(organization.id, selectedProgram.id, {
                    token: `nonce-${nonce}`,
                    amount: formatFloatValue(amountTotal),
                    expiry_month: parseInt(expiryMonth, 10),
                    expiry_year: String(expiryYear).length === 2 ? 2000 + parseInt(expiryYear, 10) : parseInt(expiryYear, 10),
                    first_name: cardBilling.first_name,
                    last_name: cardBilling.last_name,
                    name_on_card: cardBilling.name_on_card || undefined,
                    address: values.address || undefined,
                    city: values.city || undefined,
                    state: values.state_id?.label || undefined,
                    zip: values.zip || undefined,
                    application_type: 'FE',
                    '3d_secure': { eci: tds.eci, cavv: tds.authenticationValue, ds_trans_id: tds.dsTransId },
                });
                if (!depositResp?.successful) {
                    dispatch(flashMessage(depositResp?.errorMessage || 'Card payment failed. Please try again.', 'alert-danger', 'top'));
                    return;
                }
                depositHoldId = resolveDepositHoldId(depositResp);
            }

            const payload = {
                items,
                order_type: "physical_card",
                order_address: {
                    ship_to_name: values.contactName,
                    line_1: values.address,
                    line_2: values.address2,
                    city: values.city,
                    zip: values.zip,
                    country_id: COUNTRY_ID,
                    state_id: values.state_id?.value,
                    phone_number: values.phone,
                    shipping_fee: shipping.toFixed(2),
                    cards_qty: quantity,
                    state: "plastic",
                    fulfillment_fee: totalFulfillmentFee.toFixed(2),
                    visa_premium_fee: premiumFeeTotal.toFixed(2),
                    convenience_fee: calculatedConvenienceFee.toFixed(2),
                    payment_method: values?.payment_method ?? 'balance',
                },
                currency_code: "USD",
                ...(depositHoldId ? { deposit_hold_id: depositHoldId } : {}),
            };

            const response = await axios.post(`organization/${organization.id}/program/${selectedProgram.id}/physicalorder/checkout`, payload);
            if (response.status === 200 || response.status === 201) {
                dispatch(flashMessage(checkoutStatusMessage(response.data), 'alert-success', 'top'))
                setRefreshUsers(true);
                toggle();
            } else {
                console.error("Unexpected response:", response);
                const errorMsg = formatApiErrors(response.data?.errors || "Submission failed.");
                dispatch(flashMessage(errorMsg, 'alert-danger', 'top'))
            }
        } catch (e) {
            console.error(e);
            const errorMsg = formatApiErrors(e?.response?.data?.errors || e?.message || "Submission failed.");
            dispatch(flashMessage(errorMsg, 'alert-danger', 'top'));
        } finally {
            setLoading(false);
        }
    };
    const getShippingCost = (qty, currentMerchantId) => {
        const q = parseInt(qty) || 0;
        if (q === 0) return 0;

        // Safety Guard: Default to standard tiers if merchants array isn't populated yet
        if (!merchants || merchants.length === 0 || !currentMerchantId) {
            return q <= 30 ? 25 : q <= 100 ? 40 : q <= 250 ? 60 : 80;
        }

        // Locate the current active raw merchant object from local state array
        const activeMerchant = merchants.find(m => String(m.id) === String(currentMerchantId));        
        // Fallback to the hardcoded default rules matrix if merchant record does not possess custom rules
        const tiers = activeMerchant?.shipping_fees ?? [
            { min_qty: 1, max_qty: 30, fee: 25 },
            { min_qty: 31, max_qty: 100, fee: 40 },
            { min_qty: 101, max_qty: 250, fee: 60 },
            { min_qty: 251, max_qty: 500, fee: 80 }
        ];

        // Find valid matching limits tier row index
        for (const tier of tiers) {
        if (q >= parseInt(tier.min_qty) && q <= parseInt(tier.max_qty)) {
            return parseFloat(tier.fee) || 0;
        }
        }

        // Default max boundary fallback rule if out of tier brackets
        const lastTier = tiers[tiers.length - 1];
        return parseFloat(lastTier?.fee) || 80;
    };
   const ProgramTreeField = ({ input, rootProgram, organizationId }) => {
    const form = useForm();
    const handleProgramChange = async (e) => {
        const selectedId = e.target.value;
        
        // Update the field value in the form state
        input.onChange(selectedId);
        try {
            // Fetch the full details of the selected program to get its address
            const fullProgram = await getProgram(organizationId, selectedId);
            setSelectedProgram(fullProgram);
            if (!fullProgram?.allow_credit_card_payments && form.getState().values.payment_method === 'credit_card') {
                form.change('payment_method', 'balance');
                setSelectedPaymentMethod('balance');
            }
            if (fullProgram && fullProgram.address) {
                // Batch update address fields
                form.change('address', fullProgram?.address.address || '');
                form.change('address2', fullProgram?.address.address_ext || '');
                form.change('city', fullProgram?.address.city || '');
                form.change('zip', fullProgram?.address.zip || '');
                
                if (fullProgram?.address.state) {
                    form.change('state_id', { 
                        value: fullProgram?.address.state.id, 
                        label: fullProgram?.address.state.name 
                    });
                }
            }
        } catch (error) {
            console.error("Failed to update program address:", error);
        }
    };
    return (
        <SelectProgram
            rootProgram={rootProgram}
            selected={input.value}
            label={null}
            onChange={handleProgramChange}
        />
    );
    };
  return (
    <>
    <Modal className={`physical-card-wraper modal-program modal-lg ${theme.className} ${rtl.direction}-support`} isOpen={isOpen} toggle={toggle}>
            <Form
                onSubmit={onSubmitForm}
                mutators={{ ...arrayMutators }}
                enableReinitialize={true} 
                validate={values => {
                    const errors = {};
                    if (!values.merchant_id) {
                        errors.merchant_id = 'Required';
                    }
                    const rowErrors = (values.denomination_rows || []).map(row => {
                        const rowErr = {};
                        if (!row.denomination) rowErr.denomination = 'Required';
                        if (!row.qty || parseInt(row.qty, 10) < 1) rowErr.qty = 'Quantity must be 1 or greater';
                        return rowErr;
                    });
                    if (rowErrors.some(e => Object.keys(e).length > 0)) {
                        errors.denomination_rows = rowErrors;
                    }
                    if (!values.contactName?.trim()) errors.contactName = 'Required';
                    if (!values.address?.trim()) errors.address = 'Required';
                    if (!values.city?.trim()) errors.city = 'Required';
                    if (!values.state_id) errors.state_id = 'Required';
                    if (!values.zip?.trim()) errors.zip = 'Required';
                    if (!values.phone?.trim()) errors.phone = 'Required';
                    return errors;
                }}
                initialValues={initialValues}
            >
                {({ handleSubmit, form, values }) => {
                    formRef.current = form;
                    const currentSelectedMerchantId = values.merchant_id?.value || values.merchant_id;
                    const currentMerchantObj = Array.isArray(merchants) && merchants.length > 0
                        ? merchants.find(m => String(m.id) === String(currentSelectedMerchantId))
                        : null;

                    const perCardFee = parseFloat(currentMerchantObj?.fulfillment_fee_per_card) || 0.50;
    
                    const denominationRows = values.denomination_rows || [];
                    const cardQuantity = denominationRows.reduce((sum, row) => sum + (parseInt(row.qty, 10) || 0), 0);
                    const cardsSubtotal = denominationRows.reduce((sum, row) => {
                        const d = denominations.find(dm => dm.medium_info_id === (row.denomination?.value || row.denomination));
                        const price = d?.redemption_value ? parseFloat(d.redemption_value) : 0;
                        const qty = parseInt(row.qty, 10) || 0;
                        return sum + (price * qty);
                    }, 0);

                    const visaPremiumRate = parseFloat(currentMerchantObj?.visa_premium_fee) || 0;

                    const calculatedPremiumFeeTotal = (cardsSubtotal * visaPremiumRate) / 100;

                    const shippingFee = getShippingCost(cardQuantity, currentSelectedMerchantId);
                    const totalFulfillmentFee = perCardFee * cardQuantity;
                    const convenienceFeeRate = parseFloat(program?.convenience_fee) || 0;
                    const isCreditCardPayment = values?.payment_method === 'credit_card';
                    const convenienceBase = cardsSubtotal + calculatedPremiumFeeTotal + totalFulfillmentFee + shippingFee;
                    const calculatedConvenienceFee = isCreditCardPayment ? ((convenienceBase * convenienceFeeRate) / 100) : 0;
                        return (
                        <form className="form position-relative" onSubmit={handleSubmit}
                        style={{ backgroundColor: '#fff', borderRadius: '8px', overflowY: 'auto' }}>
                            {loading && (
                                <div className="modal-submit-overlay">
                                    <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <h5 className="mt-3 fw-medium text-dark">Processing your order...</h5>
                                </div>
                            )}
                       <ModalHeader tag="div" className="border-bottom-0 p-3 pb-2">
                            <div>
                            <h3 className="fw-medium mb-1" style={{ color: '#1e293b', fontSize: '16px' }}>Order Physical Cards</h3>
                            <p className="text-secondary mb-0">{program.name}</p>
                            </div>
                        </ModalHeader>
                        <ModalBody className='physical-card-body'>
                            <div className='w100'>
                            <Row className='mt-0'>
                                <Col xl="8">
                                <h5 className="fw-medium mb-1" style={{ color: '#1e293b', fontSize: '14px' }}>Program Information</h5>
                                <Row className='w100 mt-0'>
                                    {/* Program Name - Pre-populated */}
                                    <Col md="6" lg="4" xl="4">
                                        <div className="mb-2">
                                            <Label className="text-secondary small fw-medium mb-1">Select Program</Label>
                                            <Field 
                                                name="program_id"
                                                className="form-control-modern" 
                                                component={ProgramTreeField} 
                                                // rootProgram is usually the top-level program to build the tree
                                                rootProgram={organization} 
                                                // organizationId is required for the getProgram service call
                                                organizationId={organization.id}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row className='mt-0'>
                                        <Col md="8">
                                            <Field name="address">
                                                {({ input, meta }) => (
                                                    <div className="my-2 m-md-0 m-xm-0 m-xl-0">
                                                        <Label className="text-secondary small fw-medium mb-1">Address *</Label>
                                                        <Input type="text" {...input} className={`form-control-modern${meta.touched && meta.error ? ' is-invalid' : ''}`}/>
                                                        {meta.touched && meta.error && <small className="text-danger">{meta.error}</small>}
                                                    </div>
                                                )}
                                            </Field>
                                        </Col>
                                        <Col md="4">
                                            <Field name="address2">
                                                {({ input }) => (
                                                    <div className="m-0">
                                                        <Label className="text-secondary small fw-medium mb-1">Address line 2</Label>
                                                        <Input type="text" {...input} className="form-control-modern"/>
                                                    </div>
                                                )}
                                            </Field>
                                        </Col>
                                </Row>

                                <Row>
                                        <Col md="4">
                                            <Field name="city">
                                                {({ input, meta }) => (
                                                    <div className="mb-2 m-md-0 m-xm-0 m-xl-0">
                                                        <Label className="text-secondary small fw-medium mb-1">City *</Label>
                                                        <Input type="text" {...input} className={`form-control-modern${meta.touched && meta.error ? ' is-invalid' : ''}`}/>
                                                        {meta.touched && meta.error && <small className="text-danger">{meta.error}</small>}
                                                    </div>
                                                )}
                                            </Field>
                                        </Col>
                                        <Col md="4">
                                            <div className="form__form-group">
                                                <Label className="text-secondary small fw-medium mb-1">State</Label>
                                                <Field name="state_id" component={renderSelectField} options={states} className="form-control-modern"/>
                                            </div>
                                        </Col>
                                        <Col md="4">
                                            <Field name="zip">
                                                {({ input, meta }) => (
                                                    <div className="mt-2 m-md-0 m-xm-0 m-xl-0">
                                                        <Label className="text-secondary small fw-medium mb-1">Zip *</Label>
                                                        <Input type="text" {...input} className={`form-control-modern${meta.touched && meta.error ? ' is-invalid' : ''}`}/>
                                                        {meta.touched && meta.error && <small className="text-danger">{meta.error}</small>}
                                                    </div>
                                                )}
                                            </Field>
                                        </Col>
                                </Row>
                                    <Row>
                                        <Col md="6">
                                            <Field name="contactName">
                                                {({ input, meta }) => (
                                                    <div className="mb-0">
                                                        <Label className="text-secondary small fw-medium mb-1">Bulk Ship Contact Name *</Label>
                                                        <Input type="text" {...input} className={`form-control-modern${meta.touched && meta.error ? ' is-invalid' : ''}`}/>
                                                        {meta.touched && meta.error && <small className="text-danger">{meta.error}</small>}
                                                    </div>
                                                )}
                                            </Field>
                                        </Col>
                                        <Col md="6">
                                            <Field name="phone">
                                                {({ input, meta }) => (
                                                    <div className="mt-2 m-md-0 m-xm-0 m-xl-0">
                                                        <Label className="text-secondary small fw-medium mb-1">Phone Number *</Label>
                                                        <Input type="text" {...input} className={`form-control-modern${meta.touched && meta.error ? ' is-invalid' : ''}`}/>
                                                        {meta.touched && meta.error && <small className="text-danger">{meta.error}</small>}
                                                    </div>
                                                )}
                                            </Field>
                                        </Col>
                                    </Row>
                                    <h5 className="fw-medium my-3 mb-0" style={{ color: '#1e293b', fontSize: '14px' }}>Card Type</h5>
                                    <Row className="mb-2 mt-1">
                                        <Col md="12">
                                            <div className="form__form-group select-wrapper">
                                                {/* <Label className="text-secondary small fw-medium mb-1">Select Card Type</Label> */}
                                                <Field
                                                    name="merchant_id"
                                                    component={renderSelectField}
                                                    options={merchantOptions}
                                                    placeholder="Select a card type..."
                                                    className="form-control-modern"
                                                    customOnChange={(selected) => {
                                                        setMerchantID(selected?.value || null);
                                                    }}
                                                />
                                                
                                            </div>
                                        </Col>
                                        </Row>
                                        <FieldArray name="denomination_rows">
                                            {({ fields }) => (
                                                <div className="mb-4 mt-1">
                                                    {fields.map((name, index) => (
                                                        <Row key={name} className="mb-2 mt-1 align-items-end">
                                                            <Col md="5">
                                                                <div className="form__form-group select-wrapper">
                                                                    <Label className="text-secondary small fw-medium mb-1">Denomination</Label>
                                                                    <Field
                                                                        name={`${name}.denomination`}
                                                                        component={renderSelectField}
                                                                        options={denominationOptions}
                                                                        placeholder="Select denomination..."
                                                                        className="form-control-modern"
                                                                    />
                                                                </div>
                                                            </Col>
                                                            <Col md="4">
                                                                <Field name={`${name}.qty`}>
                                                                    {({ input }) => (
                                                                        <div>
                                                                            <Label className="text-secondary small fw-medium mb-1">Quantity</Label>
                                                                            <Input
                                                                                type="number"
                                                                                step="1"
                                                                                {...input}
                                                                                min="1"
                                                                                placeholder="Qty"
                                                                                className="form-control-modern"
                                                                                onKeyDown={(e) => {
                                                                                    if (['-', 'e', 'E', '.'].includes(e.key)) {
                                                                                        e.preventDefault();
                                                                                    }
                                                                                }}
                                                                                onChange={(e) => {
                                                                                    const val = e.target.value;
                                                                                    if (val === '') {
                                                                                        input.onChange('');
                                                                                        return;
                                                                                    }
                                                                                    const cleanVal = Math.abs(parseInt(val, 10)) || 1;
                                                                                    input.onChange(cleanVal);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </Field>
                                                            </Col>
                                                            {/* <Col md="3" className="d-flex align-items-end flex-column pb-1">
                                                                {fields.length > 1 && (
                                                                    <>
                                                                    <Label className="text-secondary small fw-medium mb-1">&nbsp;&nbsp;&nbsp;</Label>
                                                                    <Button
                                                                        type="button"
                                                                        size="sm"
                                                                        color="danger"
                                                                        outline
                                                                        onClick={() => fields.remove(index)}
                                                                        style={{ width: '100%' }}
                                                                        className="m-0"
                                                                    >
                                                                        Remove
                                                                    </Button>
                                                                    </>
                                                                )}
                                                            </Col> */}
                                                        </Row>
                                                    ))}
                                                    {/* <Button
                                                        type="button"
                                                        size="sm"
                                                        outline
                                                        color="primary"
                                                        className="mt-1"
                                                        onClick={() => fields.push({ denomination: null, qty: 1 })}
                                                    >
                                                        + Add Denomination
                                                    </Button> */}
                                                </div>
                                            )}
                                        </FieldArray>
                                    </Col>

                                    {/* Section 3: Order Review */}
                                    <Col xl="4" className="mb-4 order-review-sidebar">
                                    <h5 className="fw-medium mb-3" style={{ color: '#1e293b', fontSize: '14px' }}>Order Review</h5>
                                    <div className="p-3 rounded-3" style={{ backgroundColor: 'rgb(252 252 252)', border: '1px solid #e2e8f0' }}>
                                        <Row className="mb-1 mt-0 align-items-center border-bottom pb-2">
                                        <Col xs="6" className="text-secondary">Card Type:</Col>
                                        <Col xs="6" className="text-end fw-semibold text-success" style={{ fontSize: '12px', letterSpacing: '0.5px' }}>PLASTIC CARD</Col>
                                        </Row>
                                        {(values.denomination_rows || []).map((row, idx) => {
                                            const d = denominations.find(dm => dm.medium_info_id === (row.denomination?.value || row.denomination));
                                            const price = d?.redemption_value ? parseFloat(d.redemption_value) : 0;
                                            const qty = parseInt(row.qty, 10) || 0;
                                            const isOnly = (values.denomination_rows || []).length === 1;
                                            return (
                                                <Row key={idx} className={`mt-0 mb-1 align-items-center pb-1${isOnly ? ' border-bottom' : ''}`}>
                                                    <Col xs="6" className="text-secondary" style={{ fontSize: '12px' }}>
                                                        {isOnly ? 'Cards:' : `$${formatFloatValue(price)} cards:`}<br/>
                                                        <small className="text-dark fw-medium">{qty} x ${formatFloatValue(price)}</small>
                                                    </Col>
                                                    <Col xs="6" className="text-end fw-medium text-dark" style={{ fontSize: '12px' }}>
                                                        ${formatFloatValue(price * qty)}
                                                    </Col>
                                                </Row>
                                            );
                                        })}
                                        {(values.denomination_rows || []).length > 1 && (
                                            <Row className="mt-0 mb-2 align-items-center border-bottom pb-2">
                                                <Col xs="6" className="text-secondary fw-medium" style={{ fontSize: '12px' }}>Cards Subtotal:</Col>
                                                <Col xs="6" className="text-end fw-medium text-dark">${formatFloatValue(cardsSubtotal)}</Col>
                                            </Row>
                                        )}
                                        <Row className="mb-2 mt-2 align-items-center border-bottom pb-2">
                                        <Col xs="6" className="text-secondary">Shipping Fee:</Col>
                                        <Col xs="6" className="text-end fw-medium text-dark">${formatFloatValue(shippingFee)}</Col>
                                        </Row>
                                        <Row className="mb-2 mt-2 align-items-center border-bottom pb-2">
                                        <Col xs="6" className="text-secondary">
                                            Fulfillment Fee:<br/>
                                            <small className="text-muted">(${formatFloatValue(perCardFee)} / card)</small>      
                                        </Col>
                                        <Col xs="6" className="text-end fw-medium text-dark">${formatFloatValue(totalFulfillmentFee)}</Col>
                                        </Row>
                                        <Row className="mb-2 mt-2 align-items-center border-bottom pb-2">
                                            <Col xs="6" className="text-secondary">
                                                Visa Premium fee:<br/>
                                                <small className="text-muted">({formatFloatValue(visaPremiumRate)}%)</small>
                                            </Col>
                                            <Col xs="6" className="text-end fw-medium text-dark">${formatFloatValue(calculatedPremiumFeeTotal)}</Col>
                                        </Row>
                                        {isCreditCardPayment && (
                                            <Row className="mb-2 mt-2 align-items-center border-bottom pb-2">
                                                <Col xs="6" className="text-secondary">
                                                    Convenience Fee:<br/>
                                                    <small className="text-muted">({formatFloatValue(convenienceFeeRate)}%)</small>
                                                </Col>
                                                <Col xs="6" className="text-end fw-medium text-dark">
                                                    ${formatFloatValue(calculatedConvenienceFee)}
                                                </Col>
                                            </Row>
                                        )}
                                        <Row className="align-items-center mt-3 align-items-center">
                                        <Col xs="6">
                                            <h5 className="fw-medium m-0" style={{ color: '#1e293b', fontSize: '14px' }}>Total Order Amount:</h5>
                                        </Col>
                                        <Col xs="6" className="text-end">
                                            <h4 className="fw-bold m-0" style={{ color: '#f97316', fontSize: '14px' }}>
                                            ${formatFloatValue((
                                                cardsSubtotal + 
                                                calculatedPremiumFeeTotal + 
                                                totalFulfillmentFee + 
                                                shippingFee + 
                                                calculatedConvenienceFee
                                            ))}
                                            </h4>
                                        </Col>
                                        </Row>
                                        </div>
                                        <Col xl="12">
                                        <div className="payment-card-balance d-flex justify-content-between align-items-center border-0 pt-2" style={{ borderStyle: 'dashed !important' }}>
                                            <span className="">Available Balance</span>
                                            <span className="fw-semibold text-dark">
                                            {availableBalance}</span>
                                        </div>
                                    </Col>
                                    </Col>
                                    
                                </Row>
                            </div>                               
                                {/* Section 4: Payment Information */}
                                <div className="mb-4" style={{ border: '1px solid #e2e8f0', borderRadius: '6px', padding: '16px' }}>
                                <h5 className="fw-medium mb-1" style={{ color: '#1e293b', fontSize: '14px' }}>Payment Method</h5>
                                <Field name="payment_method">
                                    {({ input }) => {
                                    const isBalanceSelected = input.value === 'balance';
                                    const isCreditCardSelected = input.value === 'credit_card';
                                    const creditCardEnabled = Boolean(selectedProgram?.allow_credit_card_payments);

                                    return (
                                        <Row className="g-3 mt-0">

                                            <Col xl="6">
                                                <div
                                                className={`payment-card ${isBalanceSelected ? 'active' : ''}`}
                                                onClick={() => { input.onChange('balance'); setSelectedPaymentMethod('balance'); }}
                                                >
                                                    <div className="payment-card-radio">
                                                        <span className="radio-dot"></span>
                                                    </div>
                                                    <div className="payment-card-icon">
                                                        <BankIcon size={20} color="#1e293b" />
                                                    </div>
                                                    <div className="payment-card-content">
                                                        <div className="payment-card-title">Program Balance</div>
                                                        <div className="payment-card-desc">Use funds from your program balance.</div>
                                                        {(Boolean(program.is_pay_in_advance) && isBalanceSelected) && (
                                                            <div className="payment-card-balance d-flex justify-content-between align-items-center pt-2 border-top" style={{ borderStyle: 'dashed !important' }}>
                                                            <span className="text-secondary small">Available Balance</span>
                                                            <span className="fw-semibold text-dark">
                                                            {availableBalance}</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </Col>

                                            {creditCardEnabled ? (
                                                <Col xl="6">
                                                    <div
                                                    className={`payment-card ${isCreditCardSelected ? 'active' : ''}`}
                                                    onClick={() => { input.onChange('credit_card'); setSelectedPaymentMethod('credit_card'); }}
                                                    >
                                                    <div className="payment-card-radio">
                                                        <span className="radio-dot"></span>
                                                    </div>
                                                    <div className="payment-card-icon">
                                                        <CreditCardIcon size={20} color="#1e293b" />
                                                    </div>
                                                    <div className="payment-card-content">
                                                        <div className="payment-card-title">Credit Card</div>
                                                        <div className="payment-card-desc">Charge in real time.</div>
                                                    </div>
                                                    </div>
                                                </Col>
                                            ) : (
                                                <Col xl="6">
                                                    <div className="payment-card" style={{ cursor: 'default' }}>
                                                        <div className="payment-card-icon">
                                                            <CreditCardIcon size={20} color="#cbd5e1" />
                                                        </div>
                                                        <div className="payment-card-content">
                                                            <div className="payment-card-title" style={{ color: '#94a3b8' }}>Credit Card</div>
                                                            <div className="payment-card-desc">Credit card payments have been temporarily suspended. Please contact support.</div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            )}
                                        </Row>
                                    );
                                    }}
                                </Field>

                                {selectedPaymentMethod === 'credit_card' && (
                                    <div className="mt-3 p-3" style={{ border: '1px solid #e2e8f0', borderRadius: '6px' }}>
                                        <h6 className="fw-medium mb-2" style={{ fontSize: '13px', color: '#1e293b' }}>Card Details</h6>
                                        <div id="accept-blue-container-physical" />
                                        {!ab.ready && <p className="text-muted small mb-0">Loading secure card entry…</p>}
                                        {ab.challengeVisible && <p className="text-muted small mb-0">Verifying your card with your bank…</p>}
                                        <Row className="mt-2">
                                            <Col md="6">
                                                <Input
                                                    type="text"
                                                    placeholder="First Name *"
                                                    value={cardBilling.first_name}
                                                    onChange={onBillingChange('first_name')}
                                                    className="form-control-modern mt-2"
                                                />
                                            </Col>
                                            <Col md="6">
                                                <Input
                                                    type="text"
                                                    placeholder="Last Name *"
                                                    value={cardBilling.last_name}
                                                    onChange={onBillingChange('last_name')}
                                                    className="form-control-modern mt-2"
                                                />
                                            </Col>
                                            <Col md="12">
                                                <Input
                                                    type="text"
                                                    placeholder="Name on Card"
                                                    value={cardBilling.name_on_card}
                                                    onChange={onBillingChange('name_on_card')}
                                                    className="form-control-modern mt-2"
                                                />
                                            </Col>
                                        </Row>
                                    </div>
                                )}
                                </div>

                                {/* Terms and Conditions Note */}
                                <div className="p-3 rounded-3 mb-2" style={{ backgroundColor: '#fff', border: '1px solid #e2e8f0', fontSize: '13px', color: '#64748b' }}>
                                <span className="fw-semibold text-dark">T&Cs:</span>                                 <small className="text-muted">
                                        By submitting, you agree to the{' '}
                                        <span
                                            role="button"
                                            className="text-primary text-decoration-underline"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => setShowTnC(true)}
                                        >
                                            Terms &amp; Conditions
                                        </span>
                                    </small>    
                                </div>
                            </ModalBody>
                            <ModalFooter className="border-top-0 p-4 pt-2 flex-column align-items-start gap-2">
                                
                                <ButtonToolbar className="d-flex justify-content-between w-100 m-0">
                                <Button
                                    outline
                                    className="px-4 py-2 fw-medium"
                                    style={{ borderRadius: '6px', color: '#64748b', borderColor: '#cbd5e1' }}
                                    onClick={toggle}
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    disabled={loading || (selectedPaymentMethod === 'credit_card' && !ab.ready)}
                                    className="px-4 py-2 fw-medium btn-primary"
                                >
                                    {loading ? 'Submitting...' : 'Submit Order'}
                                </Button>
                                </ButtonToolbar>
                            </ModalFooter>
                        </form>
                )}
            }
            </Form>
        </Modal>
        <Modal isOpen={showTnC} toggle={() => setShowTnC(false)} size="md" centered>
            <ModalHeader toggle={() => setShowTnC(false)}>Terms &amp; Conditions</ModalHeader>
            <ModalBody>
                <p className="text-secondary mb-3" style={{ fontSize: '14px', lineHeight: '1.6' }}>
                    Use your Visa Prepaid card anywhere Visa debit cards are accepted in the U.S. The card may not be used at any merchant, including internet and mail or telephone order merchants, outside of the U.S. Card is issued by The Bancorp Bank, N.A., Member FDIC, pursuant to a license from Visa U.S.A. Inc.
                </p>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={() => setShowTnC(false)}>Close</Button>
            </ModalFooter>
        </Modal>
    </>
  );
};

PhysicalCardModal.propTypes = {
    theme: ThemeProps.isRequired,
    rtl: RTLProps.isRequired,
    organization: PropTypes.object.isRequired, // Corrected
    data: PropTypes.object.isRequired,
};
  
export default (connect((state) => ({
    theme: state.theme,
    rtl: state.rtl,
    organization: state.organization,
    data: state.program,
    auth: state.auth // Add this to get the logged-in user
}))(PhysicalCardModal));